<template>
    <v-content class="v-content__padded">
        <base-material-card
                color="transparent"
        >
            <v-row>
                <v-col cols="9">
                    <v-row no-gutters>
                        <v-col cols="12">
                    <base-material-card
                            color="info"
                            outlined
                            icon="fal fa-poll-h"
                            :title="$t('common.description').toString() | upperFirst">

                        <blockquote>
                            <pre
                              class="blockquote v-card__description"
                              :class="{'full_height': fullHeight}"
                            >{{incident.description}}</pre>
                        </blockquote>
                      <template #actions v-if="isOutBoundaries(700, incident.description)">
                        <v-spacer/>
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-btn v-on="on" icon @click="fullHeight = !fullHeight">
                              <v-icon>{{fullHeightIcon}}</v-icon>
                            </v-btn>
                          </template>
                          {{tooltipText}}
                        </v-tooltip>
                      </template>
                    </base-material-card>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>

                        <v-col cols="12">
                            <base-material-card
                            outlined
                            color="#7CB342"
                            icon="fal fa-shield-check"
                            :title="actionsTableTitle"
                            >
                            <ActionsTable
                                :incidentActions="incident.actions"
                                :items="incident.actions"
                                :currentIncident="incident"
                                :actions="actions"
                                @update="onUpdateActionsAssignation"
                            />
                            </base-material-card>
                        </v-col>

                        <!-- ASSETS -->
                        <v-col class="pt-2" cols="12">
                            <base-material-card
                                outlined
                                icon="fal fa-folder-open"
                                color="warning"
                                :title="$t('common.assets').toString() | upperFirst"
                            >
                                <AssetsListing
                                    v-if="incident && incident.id"
                                    :assets="incident.assets"
                                    :scope="'incident'"
                                    :scopeId="incident.id"
                                    :companyId="this.getCurrentCompanyID"
                                    :themeId="incident.theme_id"
                                />
                            </base-material-card>
                        </v-col>
                        <!-- /ASSETS -->

                    </v-row>
                </v-col>
                <v-col cols="3">
                    <InformationPanel
                        @input="onInput"
                        :users="users"
                        :assigned="assigned"
                        :watchers="watcher"
                        :input="onInput"
                    >
                        <div v-if="$store.getters.isManager" class="clipable-icon">
                            <LinksSelector
                                    :title="$t('common.pingview-integration')
                                .toString() | upperFirst">
                                <template>
                                  <v-text-field
                                    class="mt-6 mb-6"
                                    :append-outer-icon="displayClipBoardIcon"
                                    :label="$t('common.link_to_api_actions')"
                                    :value="getLink('link_to_api')"
                                    @click:append-outer="copy('link_to_api')"
                                    @focus="$event.target.select()"
                                    dense flat
                                    readonly
                                  />
                                  <v-text-field
                                    clear-icon="mb-6"
                                    :append-outer-icon="displayClipBoardIcon"
                                    :label="$t('common.link_to_edit_form_incident')"
                                    :value="getLink('link_to_edit_form')"
                                    @click:append-outer="copy('link_to_edit_form')"
                                    @focus="$event.target.select()"
                                    dense flat
                                    readonly
                                  />
                                    <br>
                                    <em v-if="clipable">
                                        {{$t('common.copy_or_click_to_select')
                                        .toString() | upperFirst}}
                                    </em>
                                </template>
                            </LinksSelector>

                        </div>
                        <MainInformationSection
                          :readonly="!canEdit"
                          :items="mainInformation"
                          @click="modal.edit = true"
                        />

                        <!-- Edit Incident Modal -->
                        <v-dialog v-model="modal.edit" width="450">
                            <IncidentForm
                              :incident="editableIncident"
                              kind="update"
                              @cancel="onCancel"
                              @submit="onSubmit"
                              :themes="themes"
                            />
                        </v-dialog>
                        <!-- End: Edit Incident Modal -->

                    </InformationPanel>
                </v-col>
            </v-row>
        </base-material-card>


      <v-dialog v-model="modal.copyLinkToClipboard" width="450">
        <LinkCard :title="modalLinkTitle" :content="modalLinkContent" @close="reset"/>
      </v-dialog>

    </v-content>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { upperFirst, get } from 'lodash';
import moment from 'moment';
import InformationPanel from '@/common/InformationPanel.vue';
import MainInformationSection from '@/common/MainInformationSection.vue';
import ActionsTable from '@/views/app/incidents/_actions.vue';
import IncidentForm from '@/views/app/incidents/_form.vue';
import clipableMixin from '@/views/app/gembaboard/mixins/clipableMixin';
import textUtils from '@/mixins/textUtils';
import LinkCard from '@/common/ExternalLinkCard.vue';
import LinksSelector from '@/common/linksSelector.vue';
import AssetsListing, { EAssetListingEmits } from '@/common/assets/AssetsListing.vue';

const incidentFactory = (payload = undefined) => Object.assign({}, {
    id: null,
    title: '',
    description: '',
    // eslint-disable-next-line @typescript-eslint/camelcase
    created_at: moment.now(),
    // eslint-disable-next-line @typescript-eslint/camelcase
    updated_at: moment.now(),
    watcher: [],
    assigned: [],
    actions: [],
    level: {
        name: '',
    },
    author: {
        // eslint-disable-next-line @typescript-eslint/camelcase
        last_name: '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        first_name: '',
    },
    theme: {
        name: '',
        site: {
            name: '',
        },
        workplace: {
            name: '',
        },
        workstation: {
            name: '',
        },
    },
}, payload);

export default {
    name: 'IncidentView',
    components: {
        IncidentForm,
        ActionsTable,
        MainInformationSection,
        InformationPanel,
        LinkCard,
        LinksSelector,
        AssetsListing,
    },
    mixins: [clipableMixin, textUtils],
    props: {
        incidentID: {
            type: String,
            required: true,
            default: null,
        },
        themeID: {
            type: String,
            required: true,
            default: null,
        },
    },
    data() {
        return {
            modal: {
                edit: false,
                copyLinkToClipboard: false,
            },
            search: '',
            actionKind: 'fetch',
            incident: incidentFactory(),
            actionsTableTitle: upperFirst(this.$t('common.actions')),
            defaultIncident: incidentFactory(),
            EAssetListingEmits,
        };
    },
    computed: {
        canEdit() {
            if (this.isManager) {
                return true;
            }
            return this.currentUser.id === this.incident.author.id;
        },
        ...mapGetters(['getCurrentCompanyID', 'isManager']),
        ...mapState({
            currentUser: state => state.currentUser,
        }),
        ...mapState('actions', {
            actions: state => state.actions,
        }),
        ...mapState('entities', {
            users: state => state.users.map(u => ({
                ...u,
                name: `${u.first_name} ${u.last_name}`,
            })),
        }),
        ...mapState('locations', {
            sites: state => state.sites,
            workplaces: state => state.workPlaces,
            workstations: state => state.workStations,
        }),
        ...mapState('themes', {
            themes: state => state.themes,
        }),
        editableIncident() {
            const incident = {
                ...this.incident,
                // eslint-disable-next-line @typescript-eslint/camelcase
                created_for: moment(this.incident.created_for).toDate(),
            };
            return { ...incident };
        },
        watcher() {
            return get(this, 'incident.watcher', [])
                .map(w => w.id);
        },
        assigned() {
            return get(this, 'incident.assigned', [])
                .map(w => w.id);
        },
        mainInformation() {
            return [{
                value: this.incident.title,
                text: this.$t('common.title'),
            }, {
                value: get(this.incident, 'level.name', ''),
                text: this.$t('common.level'),
            }, {
                value: get(this.incident, 'theme.name', ''),
                text: this.$t('common.theme'),
            }, {
                value: `${get(this.incident, 'author.first_name', '')} ${get(this.incident, 'author.last_name', '')}`,
                text: this.$t('common.author'),
            }, {
                text: this.$t('common.workplace'),
                value: get(this.incident, 'theme.workplace.name', ''),
            }, {
                text: this.$t('common.workstation'),
                value: get(this.incident, 'theme.workstation.name', ''),
            }, {
                text: this.$t('common.created_for'),
                value: this.formatDate(this.incident.created_for),
            }, {
                text: this.$t('common.updated_at'),
                value: this.formatDate(this.incident.updated_at),
            }];
        },
    },
    methods: {
        copy(type) {
            if (this.clipable) {
                this.copyToClipBoard(this.getLink(type))
                    .then(() => {
                        this.snack({
                            text: this.$t('common.copy_to_clipboard_success'),
                        });
                    })
                    .catch(() => {
                        this.snack({
                            text: this.$t('common.copy_to_clipboard_fail'),
                            color: 'error',
                        });
                    });
            } else {
                this.modalLinkContent = this.getLink(type);
                this.modalLinkTitle = this.$t('common.link_to_api');
                this.modal.copyLinkToClipboard = true;
            }
        },
        getParentToEditForm() {
            const getActionKey = key => get(this, `incident.theme.${key}`, undefined);
            if (getActionKey('site')) {
                return { parentType: 'sites', parentID: getActionKey('site').id };
            }
            if (getActionKey('workplace')) {
                return { parentType: 'workplaces', parentID: getActionKey('workplace').id };
            }
            if (getActionKey('workstation')) {
                return { parentType: 'workstations', parentID: getActionKey('workstation').id };
            }
            return {};
        },
        getLink(type) {
            if (type === 'link_to_api') {
                return `${this.getApiUrl()}/companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}/actions`;
            }
            return `${window.location.origin}/pv/incidents/${this.incidentID}`;
        },
        ...mapActions('entities', ['fetchUsers']),
        ...mapActions('actions', ['fetchActions']),
        ...mapActions('themes', ['fetchThemes']),
        reset() {
            this.modal = {
                edit: false,
                copyLinkToClipboard: false,
            };
        },
        onCancel() {
            this.reset();
        },
        onSubmit(payload) {
            return this.axios.put(`companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}`, payload)
                .catch((e) => {
                    console.error(e);
                    this.snack({
                        text: this.$t('incidents.errors.update_error_msg'),
                        color: 'error',
                    });
                })
                .then(() => this.reset())
                .then(() => this.fetchIncident());
        },
        onUpdateActionsAssignation() {
            this.fetchIncident();
        },
        onInput(payload) {
            if (payload.kind === 'watchers') {
                return this.editWatchers(payload.payload)
                    .catch((e) => {
                        console.error(e);
                        this.snack({
                            text: this.$t('incidents.errors.edit_watchers_msg'),
                            color: 'error',
                        });
                    });
            }

            if (payload.kind === 'assigned') {
                return this.editAssigned(payload.payload)
                    .catch((e) => {
                        console.error(e);
                        this.snack({
                            text: this.$t('incidents.errors.edit_assigned_msg'),
                            color: 'error',
                        });
                    });
            }
            return Promise.reject(new Error('unknown kind of action'));
        },
        editAssigned(payload) {
            const oldAssignID = this.incident.assigned.map(a => a.id);
            const idsToInsert = payload.filter(id => !oldAssignID.includes(id));
            const idsToDelete = oldAssignID.filter(id => !payload.includes(id));

            // TODO: should create an HTTP service for http calls
            return this.axios.post(`companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}/assigned`, idsToInsert) // eslint-disable-line max-len
                .then(() => Promise.all(idsToDelete.map(id => this.axios.delete(`companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}/assigned/${id}`)))) // eslint-disable-line max-len
                .then(() => this.fetchIncident());
        },
        editWatchers(payload) {
            const oldAssignID = this.incident.watcher.map(a => a.id);
            const idsToInsert = payload.filter(id => !oldAssignID.includes(id));
            const idsToDelete = oldAssignID.filter(id => !payload.includes(id));

            // TODO: should create an HTTP service for http calls
            return this.axios.post(`companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}/watcher`, idsToInsert) // eslint-disable-line max-len
                .then(() => Promise.all(idsToDelete.map(id => this.axios.delete(`companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}/watcher/${id}`)))) // eslint-disable-line max-len
                .then(() => this.fetchIncident());
        },
        formatLocalesMSG(params) {
            return this.$t(`incidents.item.errors.${this.actionKind}_error_msg`, params);
        },
        fetchIncident() {
            // TODO fetch from store and flush on destroy
            return this.$http.get(`/companies/${this.getCurrentCompanyID}/themes/${this.themeID}/incidents/${this.incidentID}`)
                .then((resp) => {
                    this.incident = incidentFactory(resp.data);
                    this.$store.commit('incidents/setCurrentIncident', this.incident);
                })
                .catch(() => this.alertError(this.formatLocalesMSG()));
        },
    },
    created() {
        this.fetchIncident()
            .then(() => this.fetchThemes())
            .then(() => this.fetchUsers())
            .then(() => this.fetchActions());
    },
};
</script>
